import React, { useMemo } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { Link } from "../common/Link";
import Gettext from "../common/Gettext";
import { fontSize } from "../common/styled-mixins";
import { Link as _Link } from "../common/Link";

import CloseIcon from "../Icons/Close";
import ShieldIcon from "../Icons/Shield";
import { HotIcon } from "../AccountType/Icons";
import Money from "../Money";

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 20003;
`;

const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
`;

const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 740px;
  color: #272b34;
  background-color: #ffcc00;
  text-align: center;
  background-image: url("img/compensation-popup_bg.png");
  background-repeat: no-repeat;
  background-position: center 9px;

  @media (max-width: 959px) {
    top: 0;
    left: 0;
    transform: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
  @media (max-width: 425px) {
    background-image: url("img/compensation-popup_bg_mob.png");
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 19px;
  right: 19px;
  display: block;
  width: 20px;
  height: 20px;
  padding: 0;
  color: #717171;
  background: transparent;
  border: none;
  cursor: pointer;
`;

const Title = styled.div`
  font-size: ${fontSize(28)};
  line-height: 1.3;
  text-transform: uppercase;
  margin-bottom: 24px;
  font-weight: 700;
  @media (max-width: 768px) {
    font-size: ${fontSize(18)};
  }
`;

const Profit = styled.div`
  font-size: ${fontSize(49)};
  margin-bottom: 24px;
  font-weight: 700;
  @media (max-width: 768px) {
    font-size: ${fontSize(22)};
  }
`;

const Button = styled(Link)`
  border: 2px solid
    ${({ theme }) => (theme.mode === "light" ? "#3B9478" : "#FFFFFF")};
  border-radius: 19px;
  font-size: ${fontSize(12)};
  line-height: 1;
  padding: 10px 46px;
  background-color: transparent;
  color: ${({ theme }) => (theme.mode === "light" ? "#3B9478" : "#FFFFFF")};
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s;
  text-transform: uppercase;
  text-decoration: none;
  :hover:not([disabled]) {
    background-color: ${({ theme }) =>
      theme.mode === "light" ? "#3B9478" : "#FFFFFF"};
    color: ${({ theme }) => (theme.mode === "light" ? "#FFFFFF" : "#3B9478")};
  }
  :disabled {
    opacity: 0.4;
  }
`;

const Body = styled.div`
  padding: 38px 30px 0;
  text-align: center;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 768px) {
    padding-right: 16px;
    padding-left: 16px;
  }
`;

const Footer = styled.div`
  position: relative;
  background-color: ${({ theme }) =>
    theme.mode === "light" ? "#F5F5F5" : "#272B34"};
  padding: 26px 37px;
  @media (max-width: 768px) {
    padding: 24px 16px 16px;
  }
`;

const FooterText = styled.div`
  max-width: 580px;
  margin: 0 auto 25px;
  text-align: center;
  color: ${({ theme }) => (theme.mode === "light" ? "#919191" : "#FFFFFF")};
  font-size: ${fontSize(14)};
  line-height: 1.3;
  mark {
    background-color: unset;
    color: ${({ theme }) => (theme.mode === "light" ? "#1B546A" : "#FFCC00")};
  }
`;

const Shields = styled.div`
  margin-bottom: 18px;
`;

const ShieldItem = styled.div`
  width: 30px;
  height: 40px;
  display: inline-block;
`;

const Table = styled.div`
  display: flex;
  justify-content: center;
  border-top: 1px solid rgba(52, 52, 52, 0.15);
  padding-top: 15px;
  padding-bottom: 17px;
  @media (max-width: 768px) {
    justify-content: space-around;
  }
`;

const TableItem = styled.div`
  margin: 0 35px;
  @media (max-width: 768px) {
    margin: 0;
  }
`;

const TableLabel = styled.div`
  color: #272b34;
  opacity: 0.55;
  margin-bottom: 4px;
  font-size: ${fontSize(12)};
  font-weight: 700;
`;

const TableValue = styled.div`
  font-size: ${fontSize(18)};
  color: #272b34;
  font-weight: 700;
`;

const Details = styled(_Link)`
  color: ${({ theme }) => (theme.mode === "light" ? "#0085EB" : "#FFCC00")};
  position: absolute;
  left: 0;
  top: 10px;
  font-size: ${fontSize(12)};
  @media (max-width: 959px) {
    position: relative;
  }
`;

const FooterButtons = styled.div`
  position: relative;
  @media (max-width: 959px) {
    display: flex;
    justify-content: center;
  }
`;

const BonusSticker = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 42px;
  height: 42px;
`;

export const getAmountLimit = compensations => {
  if (compensations != null && compensations["demo"]) {
    const sorted = compensations["demo"].items.sort((a, b) => {
      return +new Date(b.created) - +new Date(a.created);
    });
    return sorted.length > 0 ? sorted[0]["amount_limit"] : 0;
  }
};

const CompensationPopup = props => {
  const memoizedHotIcon = useMemo(() => <HotIcon />, []);
  const memoizedShieldIcon = useMemo(
    () => (
      <ShieldItem>
        <ShieldIcon />
      </ShieldItem>
    ),
    []
  );

  const amountLimit = useMemo(() => getAmountLimit(props.compensations), [
    props.compensations
  ]);

const haveUserRealAccount = props.real === 1;

  return (
    <Wrapper>
      <Overlay onClick={props.onClose} />
      <Container>
        <CloseButton onClick={props.onClose}>
          <CloseIcon />
        </CloseButton>
        <Body>
          <Title>
            <Gettext>You have used all risk-free trades!</Gettext>
          </Title>
          <Shields>
            {memoizedShieldIcon}
            {memoizedShieldIcon}
            {memoizedShieldIcon}
            {memoizedShieldIcon}
            {memoizedShieldIcon}
          </Shields>
          <Profit>
            <Gettext>Your profit</Gettext>: <Money>{props.profit}</Money>
          </Profit>
          <Table>
            <TableItem>
              <TableLabel>
                <Gettext>You've saved</Gettext>:
              </TableLabel>
              <TableValue>
                <Money>{props.compensated}</Money>
              </TableValue>
            </TableItem>
          </Table>
        </Body>

        {!haveUserRealAccount && <Footer>
          <BonusSticker>{memoizedHotIcon}</BonusSticker>
          {amountLimit && (
            <FooterText>
              {/* prettier-ignore */}
              <Gettext>
                Don't worry about losing real money! Now we give newbie traders,
                who made their first deposit, {
                  <mark>
                    <Gettext>
                      5 risk-free trades that can be used for all deals up to {<Money>{amountLimit}</Money>}
                    </Gettext>
                  </mark>
                }
              </Gettext>
            </FooterText>
          )}
          <FooterButtons>
            {false && (
              <Details to="#">
                <Gettext>details</Gettext>
              </Details>
            )}
            <Button to="/fillup">
              <Gettext>Use bonus</Gettext>
            </Button>
          </FooterButtons>
        </Footer>}
      </Container>
    </Wrapper>
  );
};

function mapStateToProps(state) {
  return {
    real: state.profile.real
  };
}


export default connect(mapStateToProps)(CompensationPopup);



// WEBPACK FOOTER //
// ./src/components/TradeModals/CompensationPopup.js